// Module
var code = `<template class="wizard-steps">
  <require from="./wizard-steps.scss"></require>
  <div repeat.for="s of steps" class="wizard-steps__step">
    <div class="wizard-steps__number">
      <div class="wizard-steps__connector" if.bind="\$index !== 0"></div>
      <div class="wizard-steps__number-background wizard-steps__number-background--\${\$index === currentStep ? 'active' : \$index > currentStep ? 'upcoming' : 'completed'}">
        <span if.bind="\$index >= currentStep">\${\$index + 1}</span><mdc-icon else>done</mdc-icon>
      </div>
    </div>
    <div class="wizard-steps__label">\${s}</div>
  </div>
</template>
`;
// Exports
export default code;